import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Paper,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDataContext } from "../../context/Context";

export default function TransferForm({ data }) {
  const { bankTransferData, getBankTransfer } = useDataContext();
  const [destinationAccount, setDestinationAccount] = useState("");
  const [amount, setAmount] = useState("");
  const [bankList, setBankList] = useState([]);

  useEffect(() => {
    getBankTransfer();
  }, []);

  useEffect(() => {
    setBankList(bankTransferData || []);
  }, [bankTransferData]);

  const handleSubmit = (e) => {
      e.preventDefault();
      
    // console.log(
    //   `Transferring ${amount} from ${data.row.accountName} to ${destinationAccount}`
    // );
  };

  return (
    <Paper
      elevation={3}
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 5,
        p: 3,
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography variant="h5" align="center" gutterBottom>
        Transfer Funds
      </Typography>

      <form onSubmit={handleSubmit}>
        {/* Source Account (Read Only) */}
        <TextField
          label="Source Account"
          fullWidth
          margin="normal"
          value={data.row.accountName}
          InputProps={{ readOnly: true }}
        />

        {/* Destination Account */}
        <FormControl fullWidth margin="normal">
          <InputLabel>Destination Account</InputLabel>
          <Select
            value={destinationAccount}
            onChange={(e) => setDestinationAccount(e.target.value)}
          >
            {bankList.map((account) => (
              <MenuItem key={account.accountNumber} value={account.accountName}>
                {account.accountName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Amount Input */}
        <TextField
          label="Amount"
          type="number"
          fullWidth
          margin="normal"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        {/* Submit Button */}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Transfer
        </Button>
      </form>
    </Paper>
  );
}
